var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Bar',{ref:"chart",attrs:{"id":_vm.chartId,"chartOptions":_vm.options,"chartData":_vm.chartData},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }